const lang = {
    actionButton: {
        confirm: 'Confirm',
        cancel: 'Cancel',
    },
};
export default lang;
